// extracted by mini-css-extract-plugin
export default {"button":"Backbutton_button__J6n+s"};